import React, { useState, useRef, useEffect } from "react"
import { Col, Form, Row } from "react-bootstrap"

//components
import Table from "../../Components/TableTemplate/Table"
import Navbar from "../../Components/Navbar/Navbar"
import DeleteModal from "../../Components/Modals/DeleteModal"
import AddModal from "../../Components/Modals/AddModal"
import EditModal from "../../Components/Modals/EditModal"
import ViewModal from "../../Components/Modals/ViewModal"
import downloadIcon from "../../Assets/Images/download_icon.png"

//css
import "./Manage.css"
import "../../Components/Navbar/Navbar.css"

import {
  dateFormat,
  getType,
  refreshPage,
  toastStyle,
} from "../../Helpers/Utils/Common"
import toast from "react-hot-toast"
import * as XLSX from "xlsx"

import {
  getAllSuppliers,
  createSupplier,
  getSupplier,
  deleteSupplier,
  searchSupplier,
  updateSupplier,
} from "../../Helpers/apiCalls/suppliersApi"
import { validateSuppliers } from "../../Helpers/Validation/Manage/SuppliersValidation"
import InputError from "../../Components/InputError/InputError"
import Footer from "../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination"

export default function Suppliers() {
  const accountType = getType()
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [selectedRow, setSelectedRow] = useState({})
  const [excelData, setExcelData] = useState([])

  const [filterConfig, setFilterConfig] = useState({
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }
  const handleTabSelect = (tabKey) => {
    setFilterConfig((prev) => {
      return { ...prev, tab: tabKey }
    })
  }

  const xlsxHeaders = [
    "COMPANY NAME",
    "ADDRESS",
    "CONTACT PERSON",
    "PHONE NUMBER",
    "TYPE",
    "COMPANY EMAIL",
    "TERMS",
  ]

  // const isInitialMount = useRef(true);
  // const filterConfigKey = 'manage-suppliers-filterConfig';

  // useEffect(()=>{
  //     if(isInitialMount.current){
  //         isInitialMount.current = false;
  //         setFilterConfig((prev) => {
  //             //
  //             if (window.localStorage.getItem(filterConfigKey) != null){
  //                 //
  //                 handleTabSelect(JSON.parse(window.localStorage.getItem(filterConfigKey)).tab);
  //                 return JSON.parse(window.localStorage.getItem(filterConfigKey))
  //             } else {
  //                 return {...prev}
  //             }
  //         });
  //     } else {
  //         window.localStorage.setItem(filterConfigKey, JSON.stringify(filterConfig));
  //     }
  // }, [filterConfig])

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)

  // VIEW
  const [showViewSupplierModal, setShowViewSupplierModal] = useState(false)
  const handleShowViewSupplierModal = () => setShowViewSupplierModal(true)
  const handleCloseViewSupplierModal = () => setShowViewSupplierModal(false)

  // EDIT
  const [showEditSupplierModal, setShowEditSupplierModal] = useState(false)
  const handleShowEditSupplierModal = () => setShowEditSupplierModal(true)
  const handleCloseEditSupplierModal = () => setShowEditSupplierModal(false)

  // ADD
  const [showAddSupplierModal, setShowAddSupplierModal] = useState(false)
  const handleShowAddSupplierModal = () => setShowAddSupplierModal(true)
  const handleCloseAddSupplierModal = () => setShowAddSupplierModal(false)
  const [suppliersDataMango, setSuppliersDataMango] = useState([])
  const [supplierData, setSupplierData] = useState({})
  const [selectedID, setSelectedID] = useState("")
  const [supplierDetails, setSupplierDetails] = useState({
    trade_name: "",
    trade_address: "",
    bir_name: "",
    bir_address: "",
    tin: "",
    terms: 0,
    requirements: "",
    phone_no: "",
    email: "",
    contact_person: "",
    bank_primary: "",
    bank_alternate: "",
    payee: "",
    supplier_type: "office supplies",
    wth_percentage: 0,
  })

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    bir_name: false,
    trade_name: false,
    trade_address: false,
    tin: false,
    contact_person: false,
    phone_no: false,
    payee: false,
    vat_type: false,
    withholding_percentage: false,
  })

  //onEdit
  function handleOnEdit() {
    handleCloseViewSupplierModal()
    handleShowEditSupplierModal()
  }

  //DELETE or REMOVE SUPPLIER
  function handleDeleteSupplier() {
    removeSupplier(selectedID)
  }
  //DROPDOWN
  function handleSelectChange(e, row) {
    fetchSupplier(row.id, row.type)
    setSelectedID(row.id)
    setSelectedRow(row)
    if (e.target.value === "delete-supplier") {
      handleShowDeleteModal()
    } else if (e.target.value === "edit-supplier") {
      handleShowEditSupplierModal()
    } else if (e.target.value === "view-supplier") {
      handleShowViewSupplierModal()
    } else {
      handleShowDeleteModal()
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-supplier" className="color-options">
          View
        </option>
        <option value="edit-supplier" className="color-options">
          Edit
        </option>
        {accountType === "admin" && (
          <option value="delete-supplier" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  const handleAddChange = (e) => {
    const { name, value } = e.target

    if (name === "vat_type") {
      var percentage =
        value === "vat" || value === "VAT"
          ? supplierData.withholding_percentage
          : ""
      setSupplierDetails((prevState) => ({
        ...prevState,
        [name]: value,
        withholding_percentage: percentage,
      }))
    } else {
      setSupplierDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
  }

  //API CALL
  async function fetchAllSuppliers() {
    setShowLoader(true)

    //MANGO
    const response = await getAllSuppliers()
    setShowLoader(false)
    if (response.response) {
      var suppliersList = response.response.data
      response.response.data.map(
        (data, key) => (suppliersList[key].company_name = data.trade_name)
      )
      response.response.data.map(
        (data, key) =>
          (suppliersList[key].address = data.trade_address || "N/A")
      )
      response.response.data.map(
        (data, key) =>
          (suppliersList[key].phone_number = data.phone_no || "N/A")
      )
      response.response.data.map(
        (data, key) =>
          (suppliersList[key].contact_person = data.contact_person || "N/A")
      )
      response.response.data.map(
        (data, key) =>
          (suppliersList[key].company_email = data.company_email || "N/A")
      )
      setSuppliersDataMango(suppliersList)
    } else {
      setSuppliersDataMango([])
    }

    setShowLoader(false)
    setShowLoader(false)
  }

  async function fetchSupplier(id, shop) {
    const response = await getSupplier(id)
    if (response.response.data) {
      var supplier = response.response.data[0]
      setSupplierData({
        added_on: supplier.added_on,
        added_by_name: supplier.added_by_name,
        supplier_id: supplier.id,
        trade_name: supplier.trade_name,
        trade_address: supplier.trade_address,
        bir_name: supplier.bir_name,
        bir_number: supplier.bir_number,
        bir_address: supplier.bir_address,
        tin: supplier.tin,
        terms: supplier.terms,
        requirements: supplier.requirements,
        phone_no: supplier.phone_no,
        supplier_type: supplier.supplier_type,
        email: supplier?.email,
        contact_person: supplier.contact_person,
        bank_primary: supplier.bank_primary,
        primary_account_no: supplier.primary_account_no,
        primary_account_name: supplier.primary_account_name,
        bank_alternate: supplier.bank_alternate,
        alternate_account_no: supplier.alternate_account_no,
        alternate_account_name: supplier.alternate_account_name,
        payee: supplier.payee,
        vat_type: supplier.vat_type,
        withholding_percentage: supplier.withholding_percentage
          ? parseFloat(supplier.withholding_percentage).toString()
          : "",
      })
    } else {
      setSupplierData({})
    }
  }

  async function handleSaveSupplier() {
    if (validateSuppliers(supplierDetails, setIsError)) {
      setIsClicked(true)
      const response = await createSupplier(supplierDetails)
      if (response.response) {
        toast.success(response.response.message, {
          style: toastStyle(),
        })
        handleCloseAddSupplierModal()
        refreshPage()
      } else {
        toast.error("Error Creating New Supplier", {
          style: toastStyle(),
        })
      }
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      })
    }
  }

  async function handleEditSupplier() {
    if (validateSuppliers(supplierData, setIsError)) {
      setIsClicked(true)
      const response = await updateSupplier(supplierData)
      if (response.response) {
        toast.success(response.response.message, {
          style: toastStyle(),
        })
        setTimeout(() => {
          refreshPage()
        }, 1000)
      } else {
        toast.error("Error Updating New Supplier", {
          style: toastStyle(),
        })
        setTimeout(() => {
          refreshPage()
        }, 1000)
      }
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      })
    }
  }

  async function removeSupplier(id) {
    setIsClicked(true)
    const response = await deleteSupplier(id)
    if (response.data) {
      toast.success("Successfully deleted user!", {
        style: toastStyle(),
      })
      handleCloseDeleteModal()
      refreshPage()
    } else {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      })
    }
  }

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value }
    })
  }

  //API CALL
  async function fetchSuppliers() {
    setTotalItems(0)
    setSuppliersDataMango([])
    setExcelData([])
    setShowLoader(true)

    const response = await searchSupplier(filterConfig)
    setShowLoader(false)
    if (response.response) {
      var suppliersList = response.response.data
      response.response.data.map(
        (data, key) => (suppliersList[key].company_name = data.trade_name)
      )
      response.response.data.map(
        (data, key) =>
          (suppliersList[key].address = data.trade_address || "N/A")
      )
      response.response.data.map(
        (data, key) =>
          (suppliersList[key].phone_number = data.phone_no || "N/A")
      )
      response.response.data.map(
        (data, key) =>
          (suppliersList[key].contact_person = data.contact_person || "N/A")
      )
      response.response.data.map(
        (data, key) =>
          (suppliersList[key].company_email = data.company_email || "N/A")
      )

      setSuppliersDataMango(suppliersList)
      setTotalItems(response.response.size)

      var excel = suppliersList.map((bill) => {
        var info = {}
        info.trade_name = bill.trade_name
        info.trade_address = bill.trade_address
        info.contact_person = bill.contact_person
        info.phone_no = bill.phone_no
        info.supplier_type = bill.supplier_type
        info.email = bill.email
        info.terms = bill.terms
        return info
      })
      setExcelData(excel)
    }
    setShowLoader(false)
  }

  //EDIT OR UPDATE FORWARDER
  const handleEditChange = (e) => {
    const { name, value } = e.target
    if (name === "vat_type") {
      var percentage =
        value === "vat" || value === "VAT"
          ? supplierData.withholding_percentage
          : ""
      setSupplierData((prevState) => ({
        ...prevState,
        [name]: value,
        withholding_percentage: percentage,
      }))
    } else {
      setSupplierData((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
  }

  function handleExport() {
    const rows = excelData

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "Suppliers.xlsx", { compression: true })
  }

  useEffect(() => {
    fetchSuppliers()
  }, [filterConfig, currentPage])

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"MANAGE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              SUPPLIERS{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              className="search-bar"
              name="name"
              placeholder="Search name..."
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <button className="add-btn" onClick={handleShowAddSupplierModal}>
                Add
              </button>
            </div>
          </Col>
        </Row>
        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Form.Select
                name="supplier_type"
                className="date-filter force-width w-full"
                value={filterConfig.supplier_type}
                onChange={(e) => handleOnSearch(e)}
              >
                <option value="" selected>
                  All Supplier Types
                </option>
                <option value="office supplies">Office Supplies</option>
                <option value="technology">Technology</option>
                <option value="bills payment">
                  Bills payment - Water, Electric , Internet, Aircon
                </option>
                <option value="rental payment">Rental Payment</option>
                <option value="insurance">Insurance</option>
                <option value="shipping freight forwarder">
                  Shipping Freight Forwarder
                </option>
              </Form.Select>
            </Col>
          </Row>
          <div className="mb-2" />

          {/* TABLE */}
          <TableWithDynamicPagination
            tableHeaders={
              accountType === "admin"
                ? [
                    "COMPANY NAME",
                    "ADDRESS",
                    "CONTACT PERSON",
                    "PHONE NUMBER",
                    "TYPE",
                    "COMPANY EMAIL",
                    "TERMS",
                    "ACTIONS",
                  ]
                : [
                    "COMPANY NAME",
                    "ADDRESS",
                    "CONTACT PERSON",
                    "PHONE NUMBER",
                    "TYPE",
                    "COMPANY EMAIL",
                    "TERMS",
                  ]
            }
            headerSelector={[
              "trade_name",
              "trade_address",
              "contact_person",
              "phone_no",
              "supplier_type",
              "email",
              "terms",
            ]}
            tableData={suppliersDataMango}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
            // used in dynamic pagination
            totalItems={totalItems}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handlePageChange={handlePageChange}
          />
        </div>
        <div className="mb-3" />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>

      {/* MODALS */}
      <DeleteModal
        text="supplier"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteSupplier}
        isClicked={isClicked}
      />
      <AddModal
        title={`SUPPLIER`}
        show={showAddSupplierModal}
        onHide={handleCloseAddSupplierModal}
        onSave={handleSaveSupplier}
        isClicked={isClicked}
      >
        <div className="mt-3 ">
          <Row className="nc-modal-custom-row mt-0">
            <Col xs={12} lg={6}>
              BIR NAME{" "}
              <Form.Control
                type="text"
                name="bir_name"
                value={supplierDetails.bir_name}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TRADE NAME <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_name"
                value={supplierDetails.trade_name}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.trade_name}
                message={"Trade name is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              BIR-REGISTERED ADDRESS
              <Form.Control
                type="text"
                name="bir_address"
                value={supplierDetails.bir_address}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TRADE ADDRESS <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_address"
                value={supplierDetails.trade_address}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.trade_address}
                message={"Trade address is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              TIN NUMBER{" "}
              <Form.Control
                type="text"
                name="tin"
                value={supplierDetails.tin}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              BIR NUMBER
              <Form.Control
                type="text"
                name="bir_number"
                className="nc-modal-custom-input"
                value={supplierDetails.bir_number}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            {/* <Col xs={12} lg={4} className="mt-2 mt-lg-0 nc-modal-custom-row-details">
                            TERM (DAYS)
                            <Form.Control
                                type="text"
                                name="terms"
                                value={supplierDetails.terms}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                            />
                        </Col> */}
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xl={4} className="mt-2 mt-lg-0">
              CONTACT PERSON <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="contact_person"
                value={supplierDetails.contact_person}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.contact_person}
                message={"Contact Person is required"}
              />
            </Col>
            <Col xl={4} className="mt-2 mt-lg-0">
              PHONE NUMBER <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="phone_no"
                value={supplierDetails.phone_no}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.phone_no}
                message={"Phone number is required"}
              />
            </Col>
            <Col className="mt-2 mt-lg-0">
              PAYEE <label className="badge-required">{` *`}</label>
              <Form.Control
                type="email"
                name="payee"
                value={supplierDetails.payee}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.payee}
                message={"Payee is required"}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              PRIMARY BANK NAME
              <Form.Control
                type="text"
                name="bank_primary"
                value={supplierDetails.bank_primary}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PRIMARY ACCOUNT NO.
              <Form.Control
                type="number"
                name="primary_account_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                required
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PRIMARY ACCOUNT NAME
              <Form.Control
                type="text"
                name="primary_account_name"
                className="nc-modal-custom-input"
                required
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              ALTERNATE BANK NAME
              <Form.Control
                type="text"
                name="bank_alternate"
                value={supplierDetails.bank_alternate}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              ALTERNATE ACCOUNT NO.
              <Form.Control
                type="number"
                name="alternate_account_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                required
                value={supplierDetails.alternate_account_no}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              ALTERNATE ACCOUNT NAME
              <Form.Control
                type="text"
                name="alternate_account_name"
                className="nc-modal-custom-input"
                value={supplierDetails.alternate_account_name}
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              TYPE
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="supplier_type"
                value={supplierDetails.supplier_type}
                onChange={(e) => handleAddChange(e)}
              >
                <option value="" hidden>
                  Select
                </option>
                <option value="office supplies">Office Supplies</option>
                <option value="technology">Technology</option>
                <option value="bills payment">
                  Bills payment - Water, Electric , Internet, Aircon
                </option>
                <option value="rental payment">Rental Payment</option>
                <option value="insurance">Insurance</option>
                <option value="shipping freight forwarder">
                  Shipping Freight Forwarder
                </option>
              </select>
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              COMPANY EMAIL
              <Form.Control
                type="email"
                name="email"
                value={supplierDetails.email}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              TERM (DAYS)
              <Form.Control
                type="text"
                name="terms"
                value={supplierDetails.terms}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              VAT Type <label className="badge-required">{` *`}</label>
              <Row className="mb-3">
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="VAT"
                      name="vat_type"
                      value="vat"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="NVAT"
                      name="vat_type"
                      value="nvat"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <InputError
                isValid={isError.vat_type}
                message={"VAT type is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              BIR 2307{" "}
              {supplierDetails.vat_type === "vat" && (
                <label className="badge-required">{` *`}</label>
              )}
              <Row className="mb-3">
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                      <Form.Check
                        type="radio"
                        label="0.5%"
                        name="withholding_percentage"
                        value="0.5"
                        className="pt-2"
                        onChange={(e) => handleAddChange(e)}
                        checked={
                          supplierDetails.withholding_percentage === "0.5" &&
                          supplierDetails.vat_type !== "nvat"
                        }
                        disabled={
                          supplierDetails.vat_type === "nvat" ? true : false
                        }
                      />
                    </Form.Group>
                </Col>
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="1%"
                      name="withholding_percentage"
                      value="1"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        supplierDetails.withholding_percentage === "1" &&
                        supplierDetails.vat_type !== "nvat"
                      }
                      disabled={
                        supplierDetails.vat_type === "nvat" ? true : false
                      }
                    />
                  </Form.Group>
                </Col>
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="2%"
                      name="withholding_percentage"
                      value="2"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        supplierDetails.withholding_percentage === "2" &&
                        supplierDetails.vat_type !== "nvat"
                      }
                      disabled={
                        supplierDetails.vat_type === "nvat" ? true : false
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <InputError
                isValid={isError.withholding_percentage}
                message={"Percentage is required"}
              />
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="SUPPLIER"
        show={showEditSupplierModal}
        onHide={handleCloseEditSupplierModal}
        onSave={handleEditSupplier}
        isClicked={isClicked}
      >
        <div className="mt-3 ">
          <Row className="nc-modal-custom-row mt-0">
            <Col xs={12} lg={6}>
              BIR NAME
              <Form.Control
                type="text"
                name="bir_name"
                value={supplierData.bir_name}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TRADE NAME
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_name"
                value={supplierData.trade_name}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
              <InputError
                isValid={isError.trade_name}
                message={"Trade name is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              BIR-REGISTERED ADDRESS
              <Form.Control
                type="text"
                name="bir_address"
                value={supplierData.bir_address}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              TRADE ADDRESS
              <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_address"
                value={supplierData.trade_address}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
              <InputError
                isValid={isError.trade_address}
                message={"Trade address is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              TIN NUMBER
              <Form.Control
                type="text"
                name="tin"
                value={supplierData.tin}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              BIR NUMBER
              <Form.Control
                type="text"
                name="bir_number"
                value={supplierData.bir_number}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              CONTACT PERSON <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="contact_person"
                value={supplierData.contact_person}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.contact_person}
                message={"Contact Person is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PHONE NUMBER <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="phone_no"
                value={supplierData.phone_no}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.phone_no}
                message={"Phone number is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PAYEE <label className="badge-required">{` *`}</label>
              <Form.Control
                type="email"
                name="payee"
                value={supplierData.payee}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.payee}
                message={"Payee is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              PRIMARY BANK NAME
              <Form.Control
                type="text"
                name="bank_primary"
                value={supplierData.bank_primary}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PRIMARY ACCOUNT NO.
              <Form.Control
                type="text"
                name="primary_account_no"
                value={supplierData.primary_account_no}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit hide-spinner numeric-input"
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PRIMARY ACCOUNT NAME
              <Form.Control
                type="text"
                name="primary_account_name"
                value={supplierData.primary_account_name}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              ALTERNATE BANK NAME
              <Form.Control
                type="text"
                name="bank_alternate"
                value={supplierData.bank_alternate}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              ALTERNATE ACCOUNT NO.
              <Form.Control
                type="text"
                name="alternate_account_no"
                value={supplierData.alternate_account_no}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit hide-spinner numeric-input"
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              ALTERNATE ACCOUNT NAME
              <Form.Control
                type="text"
                name="alternate_account_name"
                value={supplierData.alternate_account_name}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              TYPE
              <label className="badge-required">{` *`}</label>
              <select
                className="nc-modal-custom-select"
                name="supplier_type"
                value={supplierData.supplier_type}
                onChange={(e) => handleEditChange(e)}
              >
                <option value="" hidden>
                  Select
                </option>
                <option value="office supplies">Office Supplies</option>
                <option value="technology">Technology</option>
                <option value="bills payment">
                  Bills payment - Water, Electric , Internet, Aircon
                </option>
                <option value="rental payment">Rental Payment</option>
                <option value="insurance">Insurance</option>
                <option value="shipping freight forwarder">
                  Shipping Freight Forwarder
                </option>
              </select>
            </Col>
            <Col
              xs={12}
              lg={4}
              className="mt-2 mt-lg-0 nc-modal-custom-row-details"
            >
              COMPANY EMAIL
              <Form.Control
                type="email"
                name="email"
                className="nc-modal-custom-input-edit"
                value={supplierData.email}
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
            <Col
              xs={12}
              lg={4}
              className="mt-2 mt-lg-0 nc-modal-custom-row-details"
            >
              TERM (DAYS)
              <Form.Control
                type="text"
                name="terms"
                value={supplierData.terms}
                onChange={(e) => handleEditChange(e)}
                className="nc-modal-custom-input-edit"
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              VAT Type <label className="badge-required">{` *`}</label>
              <Row className="mb-3">
                <Col xs={3} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="VAT"
                      name="vat_type"
                      value="VAT"
                      className="pt-2"
                      checked={supplierData.vat_type === "VAT"}
                      onChange={(e) => handleEditChange(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="NVAT"
                      name="vat_type"
                      value="NVAT"
                      className="pt-2"
                      checked={supplierData.vat_type === "NVAT"}
                      onChange={(e) => handleEditChange(e)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <InputError
              isValid={isError.vat_type}
              message={"VAT type is required"}
            />
            <Col xs={12} lg={6} className="mt-2 mt-lg-0">
              BIR 2307
              {supplierData.vat_type === "VAT" && (
                <label className="badge-required">{` *`}</label>
              )}
              <Row className="mb-3">
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="0.5%"
                      name="withholding_percentage"
                      value="0.5"
                      className="pt-2"
                      checked={
                        supplierData.withholding_percentage === "0.5" &&
                        (supplierData.vat_type !== "nvat" ||
                          supplierData.vat_type !== "NVAT")
                      }
                      onChange={(e) => handleEditChange(e)}
                      disabled={supplierData.vat_type === "NVAT" ? true : false}
                    />
                  </Form.Group>
                </Col>
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="1%"
                      name="withholding_percentage"
                      value="1"
                      className="pt-2"
                      checked={
                        supplierData.withholding_percentage === "1" &&
                        (supplierData.vat_type !== "nvat" ||
                          supplierData.vat_type !== "NVAT")
                      }
                      onChange={(e) => handleEditChange(e)}
                      disabled={supplierData.vat_type === "NVAT" ? true : false}
                    />
                  </Form.Group>
                </Col>
                <Col xs={2} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="2%"
                      name="withholding_percentage"
                      value="2"
                      className="pt-2"
                      checked={
                        supplierData.withholding_percentage === "2" &&
                        (supplierData.vat_type !== "nvat" ||
                          supplierData.vat_type !== "NVAT")
                      }
                      onChange={(e) => handleEditChange(e)}
                      disabled={supplierData.vat_type === "NVAT" ? true : false}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <InputError
              isValid={isError.withholding_percentage}
              message={"Percentage is required"}
            />
          </Row>
        </div>
      </EditModal>
      <ViewModal
        withButtons
        show={showViewSupplierModal}
        onHide={handleCloseViewSupplierModal}
        onEdit={handleOnEdit}
      >
        <div className="mt-0">
          <div className="col-sm-12 m-0 space">
            <span className="custom-modal-body-title-supplier-details">
              SUPPLIER DETAILS
            </span>
            <div className="container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col xs={6} lg={4} className="nc-modal-custom-row-details">
                  BIR NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.bir_name} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="nc-modal-custom-row-details">
                  TRADE NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.trade_name} </Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  TIN NUMBER
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.tin} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col xs={4} lg={4} className="nc-modal-custom-row-details">
                  TERM (DAYS)
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.terms} DAYS </Col>
                  </Row>
                </Col>
                <Col xs={4} lg={4} className=" nc-modal-custom-row-details">
                  VAT TYPE
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.vat_type} </Col>
                  </Row>
                </Col>
                <Col xs={4} lg={4} className="nc-modal-custom-row-details">
                  BIR 2307
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {supplierData.withholding_percentage
                        ? supplierData.withholding_percentage + "%"
                        : ""}{" "}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col xs={12} lg={4} className="nc-modal-custom-row-details">
                  SUPPLIER TYPE
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.supplier_type} </Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  BIR-REGISTERED ADDRESS
                  <Row className="nc-modal-custom-row">
                    <Col>{supplierData.bir_address}</Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  TRADE ADDRESS
                  <Row className="nc-modal-custom-row">
                    <Col>{supplierData.trade_address}</Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
          <div className="col-sm-12 mt-3 space">
            <span className="custom-modal-body-title-bank-details">
              BANK DETAILS
            </span>
            <div className="container-wrapper">
              <Row className="nc-modal-custom-row-view mb-2">
                <Col className="nc-modal-custom-row-details">
                  PAYEE
                  <Row className="nc-modal-custom-row mt-2">
                    <Col> {supplierData.payee} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col xs={12} lg={4} className="nc-modal-custom-row-details">
                  PRIMARY BANK NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.bank_primary} </Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  PRIMARY ACCOUNT NO.
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.primary_account_no} </Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  PRIMARY ACCOUNT NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.primary_account_name} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col xs={12} lg={4} className="nc-modal-custom-row-details">
                  ALTERNATE BANK NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.bank_alternate}</Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  ALTERNATE ACCOUNT NO.
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.alternate_account_no} </Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  ALTERNATE ACCOUNT NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.alternate_account_name}</Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
          <div className="col-sm-12 mt-3 space">
            <span className="custom-modal-body-title-contact-info">
              CONTACT INFORMATION
            </span>
            <div className="container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col xs={12} lg={4} className="nc-modal-custom-row-details">
                  CONTACT PERSON
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.contact_person} </Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  PHONE NUMBER
                  <Row className="nc-modal-custom-row">
                    <Col>{supplierData.phone_no} </Col>
                  </Row>
                </Col>
                <Col
                  xs={12}
                  lg={4}
                  className="mt-4 mt-lg-0 nc-modal-custom-row-details"
                >
                  COMPANY EMAIL
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.email}</Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
          <div className="col-sm-12 mt-3 space">
            <span className="custom-modal-body-title-act">ACTIVITIES</span>
            <div className="container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col xs={6} lg={6} className="nc-modal-custom-row-details">
                  ADDED ON
                  <Row className="nc-modal-custom-row">
                    <Col> {dateFormat(supplierData.added_on)} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={6} className="nc-modal-custom-row-details">
                  ADDED BY
                  <Row className="nc-modal-custom-row">
                    <Col> {supplierData.added_by_name} </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>
      <Footer />
    </div>
  )
}
